<template>
  <a-pagination
    :class="[setClass, props.position]"
    class="bg-color-fff"
    :total="page.total"
    :current="page.pageNum"
    :page-size="page.pageSize"
    show-total
    show-jumper
    show-page-size
    :page-size-options="options"
    @change="pageChange"
    @page-size-change="pageSizeChange"
  />
</template>

<script setup>
  import Page from '@/utils/newPage'
  import { defineEmits, defineProps, reactive, toRefs } from 'vue'

  // props
  const props = defineProps({
    position: {
      default: 'flex_r',
      type: String,
    },
    options: {
      default: () => [50, 100, 200],
      type: Array,
    },
    page: {
      default: () => new Page(),
      type: Object,
      require: true,
    },
    setClass: {
      type: String,
      default: '',
    },
  })
  const emit = defineEmits(['pageChange'])

  //   state
  const state = reactive({
    page: props.page,
  })
  //   methods
  function pageChange(current) {
    state.page.pageNum = current
    emit('pageChange', state.page)
  }
  function pageSizeChange(pageSize) {
    state.page.pageSize = pageSize
    emit('pageChange', state.page)
  }
  const { page } = toRefs(state)
</script>

<style lang="less"></style>
